// extracted by mini-css-extract-plugin
export default {"loadingIcon":"LoadingView_loadingIcon_F47n2"};